import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { Modal } from 'semantic-ui-react';

import StatefulModal from 'Components/Modal/StatefulModal';

import { FILE_TYPE } from '../../common';

import NewDataContainer from './NewData.gql';

export default class ImportDataModal extends Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    id: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.oneOf(Object.values(FILE_TYPE)).isRequired,
  };
  static defaultProps = {
    isEdit: false,
    title: 'Import New File',
  };
  render() {
    const { isEdit, id, trigger, variables, title, type } = this.props;
    return (
      <StatefulModal trigger={trigger} dimmer="inverted">
        {(closeModal) => (
          <Fragment>
            <Modal.Header>{title}</Modal.Header>
            <Modal.Content>
              <NewDataContainer
                type={type}
                variables={variables}
                isEdit={isEdit}
                id={id}
                onComplete={closeModal}
                onCancelled={closeModal}
                {...this.props}
              />
            </Modal.Content>
          </Fragment>
        )}
      </StatefulModal>
    );
  }
}
